import { get, post, del } from '../request.js'

/**首页 拜访频率预警-更多列表 */
export const findVisitFrequencyList = (params) => { return get('/home/findVisitFrequencyList', params) }

// 拜访频率预警-查询前五
export const findVisitFrequencyListTop5 = (params) => { return get('/home/findVisitFrequencyListTop5', params) }

// 查询预警总数
export const findVisitFrequencyListCount = (params) => { return get('/home/findVisitFrequencyListCount', params) }

/**首页 查询账号到期-更多列表 */
export const findAccountExpirationList = (params) => { return get('/home/findAccountExpirationList', params) }

// 查询账号到期-查询前五
export const findAccountExpirationListTop5 = (params) => { return get('/home/findAccountExpirationListTop5', params) }

// 查询账号到期-查询总数
export const findAccountExpirationListCount = (params) => { return get('/home/findAccountExpirationListCount', params) }

// 查询查询产品客户数量
export const findProductCustomerCount = params => get('/home/findProductCustomerCount', params);

// 查询特殊事项数据列表
export const findSpecialMatterList = params => get('/specialMatter/list', params);

// 新增特殊事项数据
export const addSpecialMatter = params => post('/specialMatter/add', params, true);

// 编辑特殊事项数据
export const updateSpecialMatter = params => post('/specialMatter/update', params, true);

// 删除特殊事项数据
export const deleteSpecialMatter = (params) => del('/specialMatter/delete', params);